import './Metamask.scss';

const IconMetamask = () => <i className="ico-metamask" />;

export default IconMetamask;
